export const LOGO = "/logo-dark.png";
export const LOGO_WHITE = "/logo-white.png";

export const IMG = {
  heroExterior: "https://static.prod-images.emergentagent.com/jobs/fde2ed11-3ffd-4995-b660-f3364fe907ae/images/b8e411af56d6acb295ae2a8b9474c7b9cc08f0f24b28e04a789ac745346f4cf0.jpeg",
  darkFacade: "https://static.prod-images.emergentagent.com/jobs/fde2ed11-3ffd-4995-b660-f3364fe907ae/images/dcf0e6237d2069f0c706ef7d966e58504b87f760a992ccb9dc9ac58bde5a351a.jpeg",
  interiorLake: "https://static.prod-images.emergentagent.com/jobs/fde2ed11-3ffd-4995-b660-f3364fe907ae/images/258c1bb5c4241f9b5b4916b7ef01ed1e3cc76b1def22dc1fb09606b828d0e808.jpeg",
  interiorLiving: "https://static.prod-images.emergentagent.com/jobs/fde2ed11-3ffd-4995-b660-f3364fe907ae/images/dbead47fb0265d16d6878fe5e95029b42cd1c16c8c4f5d5647048af74f9ef84a.jpeg",
  interiorFire: "https://static.prod-images.emergentagent.com/jobs/fde2ed11-3ffd-4995-b660-f3364fe907ae/images/7c05638a14ef87dbef6ea2e303b5c134fa352574106d5f5691b473a5f7eeda58.jpeg",
  door1: "https://static.prod-images.emergentagent.com/jobs/fde2ed11-3ffd-4995-b660-f3364fe907ae/images/ba4d457e2182996a69796fabda287c01cd0198f9b7bbf00c82f96f9ebdd668a5.jpeg",
  door2: "https://static.prod-images.emergentagent.com/jobs/fde2ed11-3ffd-4995-b660-f3364fe907ae/images/366c9869dab0caa06fbe5808a56395811cf96ce1e40a202f75b3bb8a97681fc1.jpeg",
  sliding1: "https://static.prod-images.emergentagent.com/jobs/fde2ed11-3ffd-4995-b660-f3364fe907ae/images/86a7052cbc02b08154bba48eaac101c1099f22b757478a061377a97ff106a92e.jpeg",
  sliding2: "https://static.prod-images.emergentagent.com/jobs/fde2ed11-3ffd-4995-b660-f3364fe907ae/images/b443807d62046d77e5c71217f02d054bcb3f0c565349f872f049115734f29b21.jpeg",
  sliding3: "https://static.prod-images.emergentagent.com/jobs/fde2ed11-3ffd-4995-b660-f3364fe907ae/images/f9f4ec6d603f8a76cd351de9f4d00dbc3a7040e9fb5df2305cc8fa25d9f73e77.jpeg",
  installer: "/team-installatie.jpeg",
};

export const NAV = [
  { label: "Kozijnen", to: "/kunststof-kozijnen" },
  { label: "Deuren", to: "/deuren" },
  { label: "Schuifpuien", to: "/schuifpuien" },
  { label: "Projecten", to: "/projecten" },
  { label: "Subsidie", to: "/subsidie" },
  { label: "Over DEKO", to: "/over" },
  { label: "Contact", to: "/contact" },
];

export const PROJECTS = [
  { id: 1, cat: "Kozijnen", title: "Kunststof kozijnen", place: "Groningen", img: IMG.interiorLake },
  { id: 2, cat: "Schuifpuien", title: "Hefschuifpui op de tuin", place: "Assen", img: IMG.sliding1 },
  { id: 3, cat: "Deuren", title: "Moderne voordeur", place: "Leeuwarden", img: IMG.door1 },
  { id: 4, cat: "Kozijnen", title: "Panoramakozijnen", place: "Drenthe", img: IMG.interiorLiving },
  { id: 5, cat: "Schuifpuien", title: "Schuifpui met uitzicht", place: "Emmen", img: IMG.sliding2 },
  { id: 6, cat: "Kozijnen", title: "Grote raampartij", place: "Friesland", img: IMG.interiorFire },
  { id: 7, cat: "Deuren", title: "Entree met glas", place: "Groningen", img: IMG.door2 },
  { id: 8, cat: "Schuifpuien", title: "Slaapkamer schuifpui", place: "Drenthe", img: IMG.sliding3 },
];

export const REVIEWS = [
  { stars: 5, quote: "Van opmeten tot plaatsen: alles netjes en precies op tijd. De kozijnen zien er prachtig uit en je merkt direct verschil in warmte en geluid.", name: "Familie de Vries", place: "Groningen" },
  { stars: 5, quote: "Strakke afwerking en duidelijke communicatie. De monteurs werkten zorgvuldig en lieten alles schoon achter. Een echte aanrader.", name: "J. Hoekstra", place: "Leeuwarden" },
  { stars: 5, quote: "Onze nieuwe schuifpui is fantastisch. Eerlijk advies, scherpe prijs en vakwerk. Wij hebben DEKO al bij de buren aanbevolen.", name: "M. Bakker", place: "Assen" },
];

export const PRODUCTS = {
  "kunststof-kozijnen": {
    name: "Kunststof Kozijnen",
    hero: IMG.interiorLake,
    tagline: "Kozijnen die van uw huis een thuis maken.",
    intro: "Onze kunststof kozijnen combineren tijdloze esthetiek met uitmuntende isolatie. Strakke profielen, een naadloze afwerking en beglazing die uw woning stil, warm en energiezuinig maakt.",
    features: [
      { title: "Optimale isolatie", body: "HR++ of triple beglazing houdt warmte binnen en geluid buiten." },
      { title: "Onderhoudsvrij", body: "Hoogwaardig kunststof dat jarenlang mooi blijft, zonder schilderwerk." },
      { title: "Volledig op maat", body: "Elk kozijn wordt exact ingemeten en op maat geproduceerd." },
      { title: "Ruime kleurkeuze", body: "Van klassiek wit tot strak antraciet in mat of structuur." },
    ],
    gallery: [IMG.interiorLiving, IMG.interiorFire, IMG.darkFacade],
  },
  "deuren": {
    name: "Deuren",
    hero: IMG.door1,
    tagline: "Een entree die indruk maakt.",
    intro: "De voordeur is het visitekaartje van uw woning. Onze kunststof deuren bieden veiligheid, isolatie en een luxe uitstraling — geheel afgestemd op uw architectuur.",
    features: [
      { title: "Inbraakwerend", body: "Meerpuntsluitingen en gehard glas volgens SKG-normen." },
      { title: "Naadloze afwerking", body: "Strakke lijnen en verborgen scharnieren voor een clean design." },
      { title: "Warm en stil", body: "Geïsoleerde deurvullingen houden tocht en kou buiten." },
      { title: "Modellen op maat", body: "Van vlakke designdeuren tot varianten met zijlicht en glas." },
    ],
    gallery: [IMG.door2, IMG.interiorLiving, IMG.darkFacade],
  },
  "schuifpuien": {
    name: "Schuifpuien",
    hero: IMG.sliding1,
    tagline: "Grenzeloos wonen, binnen en buiten.",
    intro: "Een schuifpui laat het licht binnenstromen en verbindt uw woonkamer met de tuin. Grote glasvlakken, soepel schuivende panelen en een minimalistisch profiel.",
    features: [
      { title: "Maximaal glas", body: "Slanke profielen voor een zo groot mogelijk lichtoppervlak." },
      { title: "Soepel schuivend", body: "Hefschuifsystemen die moeiteloos bewegen, ook bij groot formaat." },
      { title: "Vlakke dorpel", body: "Drempelloze overgang naar terras of tuin." },
      { title: "Optimale isolatie", body: "Triple beglazing en thermische onderbreking als standaard." },
    ],
    gallery: [IMG.sliding2, IMG.sliding3, IMG.interiorLake],
  },
};
